import styled from "styled-components";

import {
  MacroTemplateContainer,
  OverviewMacroTemplateContainer,
} from "../../styles";

export const PanelsTemplatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PanelTemplate = styled(MacroTemplateContainer)`
  border-radius: 12px;
  overflow: hidden;
  padding: 24px 0px;
  cursor: pointer;
`;

export const Translate = styled.div`
  transform: translateX(24px);
`;

export const OverviewPanelsTemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
`;

export const OverviewPanelTemplate = styled(OverviewMacroTemplateContainer)`
  border: none;
  background-color: transparent;
  border-radius: 8px;
  cursor: pointer;
`;
